import React, {
    useState
} from 'react';

import { 
    IonPage,
    IonHeader,
    IonContent,
    IonToolbar,
    IonTitle,
    IonGrid,
    IonRow,
    IonCol,
    IonButtons,
    IonButton,
    IonBackButton,
    NavContext,
    IonCard,
    IonCardHeader,
    IonCardSubtitle,
    IonCardContent,
    IonCardTitle,
    IonLoading,
    useIonRouter,
    useIonViewWillEnter
} from '@ionic/react';

import { RouteComponentProps } from "react-router-dom";
import { Storage } from '@capacitor/storage';   
import NServer from "../components/NServer";
import PassCheckCtrl, { checkPasscode } from '../components/PassCheckCtrl';
import { LANGUAGE, GetStr } from "../language/Language";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';

import './Main.css'; 

interface PassData extends RouteComponentProps<{
    p1 : string,
    p2 : string,
    api : string,
    return : string
    }> 
{}

const PassCheck : React.FC<PassData> = ({match}) => {

    const [passKey, setPasskey] = useState("-- -- --");
    const [showLoading, setShowLoading] = useState(false);
    
    const router = useIonRouter();

    useIonViewWillEnter(() => {
        // check whether passcode is set or not
        checkPasscode(router);
    });

    // confirmation success
    const confirmSuccess = () => {
        router.push('/' + match.params.return + '/' + match.params.p1 + "/" + match.params.p2, "back", "pop");
    }

    const biometricSubmit = async (username : string, password : string) => {
        await sendPass(password);
    }

    const submit = async () => {
        await sendPass(passKey);
    }

    const sendPass = async (pass : string) => {

        setShowLoading(true);

        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            lock : pass,
            p1 : match.params.p1,
            p2 : match.params.p2,
        }

        var server = new NServer();
        await server.sendForm(match.params.api, state);

        setShowLoading(false);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            confirmSuccess();
        }
    }

    return (
        <IonPage>
            <IonHeader>
            </IonHeader>
            <IonContent>
                <div id="main-bk" />
                <IonToolbar color="none">
                    <IonButtons slot="start">
                        <IonBackButton defaultHref="/main" ></IonBackButton>
                    </IonButtons>
                </IonToolbar>
                <IonLoading
                    isOpen={showLoading}
                    onDidDismiss={() => setShowLoading(false)}
                    message={ GetStr(LANGUAGE.TXT_PLZ_WAIT) }
                />
                <IonGrid className="ion-no-padding main-content">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="4" size="12">
                            <PassCheckCtrl onChange={setPasskey} onSubmit={submit} onBiometric={biometricSubmit} />
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );
}

export default PassCheck;